import Vue from 'vue'
import VueRouter from 'vue-router'
import { _ } from 'core-js'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/home',
    component: () =>
        import ('@components/Layout.vue'),
    children: [{
            path: '/home',
            name: 'home',
            component: () =>
                import ('../views/Home/Home.vue')
        },
        {
            path: '/about',
            name: 'about',
            component: () =>
                import ('../views/About/About.vue')
        },
        {
            path: '/contact',
            name: 'contact',
            component: () =>
                import ('../views/Contact/Contact.vue')
        },
        {
            path: '/cheatdefender',
            name: 'cheatdefender',
            component: () =>
                import ('../views/CheatDefender/CheatDefender.vue')
        },
    ]

}, ]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

export default router